import { DateTimeUtils } from "@sazka/utils/date-time-utils";
import { BlogArticleDto, BlogServiceResponse } from "./blog-dtos";

let page = 1;
const pageSize = 12;
// eslint-disable-next-line
let loadNextEnabled = true;
let container: JQuery;
let btnLoadNext: JQuery;
let isLoading = false;
let category: number;

$(() => {
    category = environment.blogCategory;
    btnLoadNext = $("#load-next-page");
    container = $("#blog-container");

    btnLoadNext.on("click", () => {
        if (loadNextEnabled && !isLoading) {
            loadNext();
        }
    });
});

function loadNext() {
    page++;
    load(page).then((response) => {
        if (!response?.articles?.length) {
            btnLoadNext.hide();
            loadNextEnabled = false;
            return;
        }

        if (response.articles.length < pageSize) {
            loadNextEnabled = false;
            btnLoadNext.hide();
        }

        const html = response.articles.reduce((sum, article) => {
            return sum + markup(article);
        }, "");

        container.append(html);
    });
}

function load(page) {
    btnLoadNext.addClass("loading");
    isLoading = true;
    return new Promise<BlogServiceResponse>((res, rej) => {
        $.get(`/api/sazka-world/blogs?page=${page}&category=${category}`)
            .then((x) => {
                res(x);
            })
            .catch((reason) => {
                rej(reason);
            })
            .always(() => {
                isLoading = false;
                btnLoadNext.removeClass("loading");
            });
    });
}

function markup(article: BlogArticleDto) {
    const { pageUrl, name: name, shortContent: perex } = article;
    let { image: imgUrl } = article;
    imgUrl = imgUrl?.replace("~/", "/");
    const date = new Date(article.date);

    return `
    <article class="c-6 c-sm-4 c-sm2-4 c-md-4 blog-preview">
        <a href="${pageUrl?.relative}" class="content">
            <div class="inner">
                <div class="image-wrapper">
                    <div class="image-wrapper--picture">
                        <img data-object-fit src="${imgUrl}" alt="${name}" class="image">
                    </div>
                    <time class="card-tag" datetime="${date.toISOString()}">
                        <span class="tag-inner">
                            ${DateTimeUtils.formatBlogDate(new Date(date))}
                        </span>
                    </time>
                </div>
                <div class="article-content">
                    <h3 class="title">${name}</h3>
                    <span class="text">${perex}</span>
                </div>
            </div>
        </a>
    </article>
    `;
}
